webpackJsonp([1],{

/***/ 17:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(74)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(85),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_questions_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_QuizItem__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_QuizItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_QuizItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Result__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Result___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Result__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      state: "start",
      questions: __WEBPACK_IMPORTED_MODULE_0__static_questions_js__["a" /* default */],
      selectedIndex: 0,
      latest: 0,
      length: __WEBPACK_IMPORTED_MODULE_0__static_questions_js__["a" /* default */].length,
      loaded: 0,
      answers: [],
      logos: []
    };
  },

  methods: {
    answerQuestion: function answerQuestion(answer) {
      console.log('answer: ');
      console.dir(answer);

      if (this.answers[answer.question.drawOrder]) {
        console.log('overwriting image');
        this.loaded--;
      }

      this.answers[answer.question.drawOrder] = { filename: answer.question.folder + '/' + answer.image + '.png' };
      this.preloadImage(answer.question.drawOrder);

      if ("undefined" !== typeof answer.binding && this.selectedIndex + 1 < this.length) {
        this.questions[this.selectedIndex + 1].binding = answer.binding;
      }

      this.selectedIndex++;
      this.latest = Math.max(this.latest, this.selectedIndex);

      if (this.selectedIndex >= this.length) {
        this.state = "result";
      }
    },
    preloadImage: function preloadImage(index) {
      var _self = this;
      _self.answers[index].image = new Image();
      _self.answers[index].loaded = false;
      _self.answers[index].image.onload = function () {
        _self.answers[index].loaded = true;
        _self.loaded++;
        console.log('loaded: ' + _self.answers[index].filename);
      };

      _self.answers[index].image.src = './static/images/' + _self.answers[index].filename;
    },
    prevQuestion: function prevQuestion() {
      console.log('previous question');
      if (0 < this.selectedIndex) {
        this.selectedIndex--;
      }
    },
    nextQuestion: function nextQuestion() {
      console.log('next question');
      if (this.selectedIndex < this.length - 1) {
        this.selectedIndex++;
      }
    },
    restartQuiz: function restartQuiz() {
      this.state = "quiz";
      this.selectedIndex = 0;
      this.latest = 0;
    },
    initializeAnswers: function initializeAnswers() {
      console.log('initializing answers array');
      this.answers = [];
      this.answers[3] = { filename: "Shield Frame-01-01-01.png" };
      this.answers[9] = { filename: "motto/1_Sash-01-01-01.png" };
      this.answers[11] = { filename: "share-logo.png" };
      this.preloadImage(3);
      this.preloadImage(9);
      this.preloadImage(11);
    },
    start: function start() {
      this.state = "quiz";
    }
  },
  components: {
    QuizItem: __WEBPACK_IMPORTED_MODULE_1__components_QuizItem___default.a,
    Result: __WEBPACK_IMPORTED_MODULE_2__components_Result___default.a
  },
  created: function created() {
    this.questions = this.questions.map(function (obj) {
      obj.binding = 0;
      return obj;
    });
    this.initializeAnswers();
  }
});

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'quiz-item',
	props: ['question', 'index', 'selectedIndex', 'latest', 'length', 'binding'],
	data: function data() {
		return {
			name: 'q-' + this.index
		};
	},

	methods: {
		selectAnswer: function selectAnswer(question, option) {
			option.binding = "undefined" !== typeof option.binding ? option.binding : 0;

			this.$emit('answer', {
				"question": question,
				"image": option.image,
				"binding": option.binding
			});
		},
		prevQuestion: function prevQuestion() {
			if (this.showPrev) {
				this.$emit('prev');
			}
		},
		nextQuestion: function nextQuestion() {
			if (this.showNext) {
				this.$emit('next');
			}
		},
		showQuestionObj: function showQuestionObj(index) {
			return index === this.binding;
		}
	},
	computed: {
		show: function show() {
			return this.index === this.selectedIndex;
		},
		showPrev: function showPrev() {
			return this.index > 0;
		},
		showNext: function showNext() {
			return this.index < this.latest;
		}
	}
});

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blobjs__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blobjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_blobjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_canvas_toBlob__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_canvas_toBlob___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_canvas_toBlob__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_form_data__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_form_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_form_data__);









/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'Result',
  props: ['answers', 'loaded'],
  data: function data() {
    return {
      defaultBacklink: 'http://globalnews.ca/',
      imageDrawn: false,
      imageName: '',
      imageWidth: 670,
      imageHeight: 609,
      sharePlatform: '',
      shareLink: '',
      shareModalState: false,
      errorModalState: false,
      fbLoading: false,
      twLoading: false,
      tweetText: "My #CanadianCoatofArms: ",
      service: {
        local: {
          path: '//static.local.globalnews.ca/coatofarms/public/',
          refLink: 'http://static.local.globalnews.ca/coatofarms/public/mygraphic.php'
        },
        prod: {
          path: '../',
          refLink: 'http://coatofarms.globalnews.ca/mygraphic.php'
        }
      }
    };
  },

  methods: {
    drawAllImages: function drawAllImages() {
      var _this = this;

      console.log('drawing images');

      var canvas = this.$refs.canvas;
      var ctx = canvas.getContext('2d');

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.answers).forEach(function (key) {
        ctx.drawImage(_this.answers[key].image, 0, 0);
      });
    },
    getArrayLength: function getArrayLength(arr) {
      return arr.filter(function (e) {
        return e !== undefined;
      }).length;
    },
    showLoader: function showLoader() {
      return this.loaded < this.getArrayLength(this.answers);
    },
    showFinished: function showFinished() {
      if (this.loaded >= this.getArrayLength(this.answers)) {
        if (!this.imageDrawn) {
          this.drawAllImages();
        }
        this.imageDrawn = true;
        return true;
      } else {
        return false;
      }
    },
    downloadImg: function downloadImg() {
      var canvas = this.$refs.canvas;
      var ctx = canvas.getContext('2d');

      canvas.toBlob(function (blob) {
        __WEBPACK_IMPORTED_MODULE_4_file_saver___default.a.saveAs(blob, "coat-of-arms.png");
      });
    },
    uploadImg: function uploadImg() {
      var canvas = this.$refs.canvas;
      var path = this.isProd() ? this.service.prod.path : this.service.local.path;

      return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: path + 'handle-temp.php',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: "imgData=" + canvas.toDataURL()
      });
    },
    shareImage: function shareImage(platform) {
      var _self = this;

      if ('Facebook' === platform) {
        this.fbLoading = true;
      } else if ('Twitter' === platform) {
        this.twLoading = true;
      }

      if (this.imageName.length > 0) {
        var refLink = _self.generateReferralLink();
        _self.generateShareCode(platform, refLink);
      } else {
        var request = this.uploadImg();
        request.then(function (response) {
          console.log(response);

          if (!response || !response.data || !response.data.fileName) {
            throw "error uploading image";
          }

          _self.imageName = response.data.fileName.split('.')[0];
          var refLink = _self.generateReferralLink();
          _self.generateShareCode(platform, refLink);
          console.log(refLink);
        }).catch(function (error) {
          console.log(error);
          _self.showModal('error');
        });
      }
    },
    generateReferralLink: function generateReferralLink() {
      var refLink = this.isProd() ? this.service.prod.refLink : this.service.local.refLink;
      var fileName = this.imageName;
      var backLink = this.getBacklink();
      return refLink + '?name=' + encodeURIComponent(fileName) + '&ref=' + encodeURIComponent(backLink);
    },
    generateShareCode: function generateShareCode(platform, refLink) {
      if ('Facebook' === platform) {
        this.shareLink = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(refLink);
      } else if ('Twitter' === platform) {
        this.shareLink = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(this.tweetText) + encodeURIComponent(refLink);
      }
      this.sharePlatform = platform;
      this.showModal('share');
      console.log(this.shareLink);
    },
    isProd: function isProd() {
      return 'static.local.globalnews.ca' !== window.location.hostname;
    },
    getBacklink: function getBacklink() {
      return document.referrer.length > 0 ? document.referrer : this.defaultBacklink;
    },
    showModal: function showModal(type) {
      if ('share' === type) {
        this.shareModalState = true;
      } else if ('error' === type) {
        this.errorModalState = true;
      }
    },
    hideModal: function hideModal(type) {
      if ('share' === type) {
        this.shareModalState = false;
      } else if ('error' === type) {
        this.errorModalState = false;
      }
    },
    clearModal: function clearModal(type) {
      this.fbLoading = false;
      this.twLoading = false;
      this.hideModal(type);
    },
    restart: function restart() {
      this.imageDrawn = false;
      this.imageName = '';
      this.sharePlatform = '';
      this.shareLink = '';
      this.$emit('restart');
    }
  }
});

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_4__App___default.a);
  }
});

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 74:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/splash.c9deb2b.png";

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(72)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(83),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-271fbee6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(73)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(84),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cb73633c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 83:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "quiz-item card"
  }, _vm._l((_vm.question.list), function(questionObj, objIndex) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showQuestionObj(objIndex)),
        expression: "showQuestionObj(objIndex)"
      }]
    }, [_c('h4', {
      staticClass: "card-header"
    }, [(questionObj.featured) ? _c('img', {
      attrs: {
        "src": './static/images/featured/' + questionObj.featured + '.png'
      }
    }) : _vm._e(), _vm._v("\n\t  \t\t" + _vm._s(questionObj.question) + "\n\t  \t")]), _vm._v(" "), _c('div', {
      staticClass: "options card-block"
    }, [_vm._l((questionObj.options), function(option) {
      return _c('div', [_c('input', {
        attrs: {
          "type": "radio",
          "id": option.image,
          "name": _vm.name
        },
        domProps: {
          "value": option.image
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "btn btn-lg btn-primary btn-block",
        attrs: {
          "for": option.image
        },
        on: {
          "click": function($event) {
            _vm.selectAnswer(_vm.question, option)
          }
        }
      }, [_vm._m(0, true), _vm._v("\n\t\t\t       " + _vm._s(option.option) + "\n\t\t       ")])])
    }), _vm._v(" "), _c('div', {
      staticClass: "paging"
    }, [_c('i', {
      staticClass: "fa fa-chevron-left",
      class: {
        active: _vm.showPrev
      },
      on: {
        "click": _vm.prevQuestion
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.index + 1) + " / " + _vm._s(_vm.length))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-chevron-right",
      class: {
        active: _vm.showNext
      },
      on: {
        "click": _vm.nextQuestion
      }
    })])], 2)])
  }))
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "btn-label"
  }, [_c('i', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),

/***/ 84:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoader()),
      expression: "showLoader()"
    }],
    staticClass: "loader"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw"
  }), _vm._v(" "), _c('div', [_vm._v("Loading")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFinished()),
      expression: "showFinished()"
    }],
    staticClass: "finished"
  }, [_c('h3', [_vm._v("My Canadian Coat of Arms")]), _vm._v(" "), _c('canvas', {
    ref: "canvas",
    attrs: {
      "id": "canvas",
      "width": _vm.imageWidth,
      "height": _vm.imageHeight
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-button-group', [_c('b-button', {
    staticClass: "download",
    on: {
      "click": _vm.downloadImg
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Download Image")])]), _vm._v(" "), _c('b-button', {
    staticClass: "facebook",
    class: {
      loading: _vm.fbLoading
    },
    on: {
      "click": function($event) {
        _vm.shareImage('Facebook')
      }
    }
  }, [_c('i', {
    staticClass: "share-loader fa fa-circle-o-notch fa-spin fa-fw"
  }), _vm._v(" "), _c('i', {
    staticClass: "media-icon fa fa-facebook",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Share on Facebook")])]), _vm._v(" "), _c('b-button', {
    staticClass: "twitter",
    class: {
      loading: _vm.twLoading
    },
    on: {
      "click": function($event) {
        _vm.shareImage('Twitter')
      }
    }
  }, [_c('i', {
    staticClass: "share-loader fa fa-circle-o-notch fa-spin fa-fw"
  }), _vm._v(" "), _c('i', {
    staticClass: "media-icon fa fa-twitter",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Share on Twitter")])])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "start-over",
    on: {
      "click": _vm.restart
    }
  }, [_vm._v("Like it? Share it! Don't like it? "), _c('a', [_vm._v("Try Again")])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "shareModal",
      "title": 'Your image is ready to share on ' + _vm.sharePlatform,
      "visible": _vm.shareModalState,
      "hide-footer": true
    },
    on: {
      "hidden": function($event) {
        _vm.clearModal('share')
      },
      "cancel": function($event) {
        _vm.clearModal('share')
      }
    }
  }, [_c('a', {
    staticClass: "btn btn-lg btn-primary btn-block",
    class: {
      facebook: _vm.fbLoading, twitter: _vm.twLoading
    },
    attrs: {
      "href": _vm.shareLink,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.hideModal('share')
      }
    }
  }, [_vm._v("Share It!")])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "errorModal",
      "title": "Sorry! There was an error sharing your image",
      "visible": _vm.errorModalState,
      "hide-footer": true
    },
    on: {
      "hidden": function($event) {
        _vm.clearModal('error')
      },
      "cancel": function($event) {
        _vm.clearModal('error')
      }
    }
  }, [_c('b-button', {
    staticClass: "twitter",
    on: {
      "click": function($event) {
        _vm.hideModal('error')
      }
    }
  }, [_vm._v("OK")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [('start' === _vm.state) ? _c('div', [_c('div', {
    attrs: {
      "id": "splash"
    },
    on: {
      "click": _vm.start
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(80)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-primary btn-block"
  }, [_vm._v("Get Started")])])]) : _vm._e(), _vm._v(" "), ('quiz' === _vm.state) ? _c('div', _vm._l((_vm.questions), function(question, index) {
    return _c('quiz-item', {
      key: index,
      attrs: {
        "question": question,
        "index": index,
        "selectedIndex": _vm.selectedIndex,
        "latest": _vm.latest,
        "length": _vm.length,
        "binding": question.binding
      },
      on: {
        "answer": _vm.answerQuestion,
        "prev": _vm.prevQuestion,
        "next": _vm.nextQuestion
      }
    })
  })) : _vm._e(), _vm._v(" "), ('result' === _vm.state) ? _c('div', [_c('result', {
    attrs: {
      "answers": _vm.answers,
      "loaded": _vm.loaded
    },
    on: {
      "restart": _vm.restartQuiz
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var questions = [
	{
		list: [{
			question: "What's your favourite season?",
			options: [
				{
					option: "Fall",
					image: "Fall Shield BKG Icon-01-01",
					binding: 1
				},
				{
					option: "Spring",
					image: "Spring Shield BKG Icon-01-01-01-01",
					binding: 0
				},
				{
					option: "Summer",
					image: "Summer Shield BKG Icon-01-01-01-01",
					binding: 0
				},
				{
					option: "Winter",
					image: "Winter Shield BKG Icon-01-01",
					binding: 1
				}
			]
		}],
		folder: "season",
		drawOrder: 2
	},
	{
		list: [
			{
				question: "What's your favourite spring or summer sport?",
				options: [
					{
						option: "Beach Volleyball",
						image: "Volleyball Outdoor Character-01-01"
					},
					{
						option: "Football",
						image: "Football Character-01-01"
					},
					{
						option: "Lacrosse",
						image: "Lacrosse Character-01-01"
					},
					{
						option: "Rugby",
						image: "Rugby Character-01-01"
					},
					{
						option: "Soccer",
						image: "Soccer Character-01-01"
					},
					{
						option: "Swimming",
						image: "Swimming Character-01-01"
					}
				],
				featured: "Soccer Character-01-01"
			},
			{
				question: "What's your favourite winter or fall sport?",
				options: [
					{
						option: "Basketball",
						image: "Basketball Character-01-01"
					},
					{
						option: "Curling",
						image: "Curling Character-01-01-01"
					},
					{
						option: "Hockey",
						image: "Hockey Character-01-01"
					},
					{
						option: "Lacrosse",
						image: "Lacrosse Character-01-01"
					},
					{
						option: "Skating",
						image: "Skating Character-01-01-01-01"
					},
					{
						option: "Volleyball",
						image: "Volleyball Indoor Character-01-01"
					}
				],
				featured: "Curling Character-01-01-01"
			}
		],
		folder: "sport",
		drawOrder: 0
	},
	{
		list: [{
			question: "Which is the most majestic Canadian animal?",
			options: [
				{
					option: "Beaver",
					image: "Beaver-01"
				},
				{
					option: "Caribou",
					image: "Caribou-01"
				},
				{
					option: "Goose",
					image: "Geese-01"
				},
				{
					option: "Polar Bear",
					image: "Polar Bear-01"
				}
			],
			featured: "Beaver-01"
		}],
		folder: "animal",
		drawOrder: 1
	},
 	{
		list: [{
			question: "What's your favourite Canadian food?",
			options: [
				{
					option: "Bacon",
					image: "Bacon-01"
				},
				{
					option: "Doughnuts",
					image: "Doughnut-01"
				},
				{
					option: "Ketchup Chips",
					image: "Ketchup-01"
				},
				{
					option: "Maple Syrup",
					image: "Maple Syrup-01"
				},
				{
					option: "Poutine",
					image: "Poutine-01-01"
				}
			],
			featured: "Ketchup-01"
		}],
		folder: "food",
		drawOrder: 4
	},
	{
		list: [{
			question: "What's your drink of choice?",
			options: [
				{
					option: "Apple Cider",
					image: "Apple Cider-01"
				},
				{
					option: "Beer",
					image: "Beer-01"
				},
				{
					option: "Caesar",
					image: "Cesar-01"
				},
				{
					option: "Coffee",
					image: "Coffee-01"
				},
				{
					option: "Milk",
					image: "Milk-01"
				}
			],
			featured: "Cesar-01"
		}],
		folder: "drink",
		drawOrder: 5
	},
	{
		list: [{
			question: "In your spare time, what do you enjoy most?",
			options: [
				{
					option: "Art",
					image: "Art-01"
				},
				{
					option: "Movies",
					image: "Movies-01"
				},
				{
					option: "Music",
					image: "Music-01"
				},
				{
					option: "Sports",
					image: "Sports-01"
				}
			],
			featured: "Music-01"
		}],
		folder: "hobby",
		drawOrder: 6
	},
	{
		list: [{
			question: "What province or territory do you identify with most?",
			options: [
				{
					option: "Alberta",
					image: "Alberta-01-01"
				},
				{
					option: "British Columbia",
					image: "British Columbia-01-01"
				},
				{
					option: "Manitoba",
					image: "Manitoba-01-01"
				},
				{
					option: "New Brunswick",
					image: "New brunswick-01-01"
				},
				{
					option: "Newfoundland and Labrador",
					image: "Newfoundland-01-01"
				},
				{
					option: "Northwest Territories",
					image: "North West Terrorities-01-01"
				},
				{
					option: "Nova Scotia",
					image: "Nova Scotia-01-01"
				},
				{
					option: "Nunavut",
					image: "Nunavut-01-01"
				},
				{
					option: "Ontario",
					image: "Ontario-01-01"
				},
				{
					option: "Prince Edward Island",
					image: "PEI-01-01"
				},
				{
					option: "Quebec",
					image: "Quebec-01-01"
				},
				{
					option: "Saskatchewan",
					image: "Saskatchewan-01-01"
				},
				{
					option: "Yukon",
					image: "Yukon terrorities-01-01"
				}
			]
		}],
		folder: "province",
		drawOrder: 7
	},
	{
		list: [{
			question: "Choose a favourite Canadian landmark",
			options: [
				{
					option: "CN Tower",
					image: "CN Tower-01-01"
				},
				{
					option: "Niagara Falls",
					image: "Niagara Falls-01-01"
				},
				{
					option: "Parliament Hill",
					image: "Parliament Hill-01-01"
				},
				{
					option: "Rocky Mountains",
					image: "Rocky Mountains-01-01"
				},
				{
					option: "Vegreville Ukrainian Easter Egg",
					image: "Vegreville Ukrainian Easter Egg-01-01"
				}
			],
			featured: "Rocky Mountains-01"
		}],
		folder: "landmark",
		drawOrder: 8
	},
	{
		list: [{
			question: "Finally, pick a motto",
			options: [
				{
					option: "Oh Canada, Our Home And Native Land",
					image: "Oh Canada, Our Home and Native Land-01-01-01-01"
				},
				{
					option: "From Sea to Sea",
					image: "Sea to Sea-01-01-01-01"
				},
				{
					option: "Strength in Diversity",
					image: "Strength in Diversity-01-01-01-01"
				},
				{
					option: "Sorry",
					image: "Sorry-01-01-01-01"
				},
				{
					option: "Canada is eh-OK",
					image: "Canada is Eh Ok-01-01-01"
				}
			]
		}],
		folder: "motto",
		drawOrder: 10
	}
]

/* harmony default export */ __webpack_exports__["a"] = (questions);

/***/ })

},[42]);


// WEBPACK FOOTER //
// static/js/app.e33bcd6a5376d61eb60a.js